import provideHook from "@/lib/provideHook";

// Interface for localStorage
export const useStorage = provideHook(() => {
  const get = (key: string): any => {
    const value = localStorage.getItem(key);
    if (!value) return undefined;
    return JSON.parse(value);
  };
  const merge = (key: string, value: { [k: string]: any }) => {
    const current = get(key) || {};
    const newVal = { ...current, ...value };
    set(key, newVal);
  };
  const remove = (key: string) => {
    localStorage.removeItem(key);
  };
  const set = (key: string, value: any) => {
    if (value === null) {
      return remove(key);
    }
    return localStorage.setItem(key, JSON.stringify(value));
  };
  return {
    get,
    merge,
    remove,
    set
  };
});
